"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * index.ts
 **/
var Encoder = __importStar(require("./encoder"));
var Formatter = __importStar(require("./formatter"));
var encoder;
(function (encoder) {
    encoder.encodeBase64 = Encoder.encodeBase64;
    encoder.decodeBase64 = Encoder.decodeBase64;
    encoder.encodeBase64Url = Encoder.encodeBase64Url;
    encoder.decodeBase64Url = Encoder.decodeBase64Url;
    encoder.arrayBufferToHexString = Encoder.arrayBufferToHexString;
    encoder.hexStringToArrayBuffer = Encoder.hexStringToArrayBuffer;
    encoder.stringToArrayBuffer = Encoder.stringToArrayBuffer;
    encoder.arrayBufferToString = Encoder.arrayBufferToString;
})(encoder = exports.encoder || (exports.encoder = {}));
var formatter;
(function (formatter) {
    formatter.binToPem = Formatter.binToPem;
    formatter.pemToBin = Formatter.pemToBin;
})(formatter = exports.formatter || (exports.formatter = {}));
exports.default = { encoder: encoder, formatter: formatter };
//# sourceMappingURL=index.js.map